import { useGetAssignmentsQuery } from "@features/assignments/assignmentsApi";
import Assignment from "./Assignment";

const AssignmentList = () => {
  const { data: assignments, isLoading, isError } = useGetAssignmentsQuery();
  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div className="text-center">Loading...</div>;
  }

  if (!isLoading && isError) {
    content = (
      <div className="text-center text-red-500">Internal server error!</div>
    );
  }

  if (!isLoading && !isError && assignments?.length === 0) {
    content = <div className="text-center">No assignments found!</div>;
  }

  if (!isLoading && !isError && assignments?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Title</th>
            <th className="table-th">Video Title</th>
            <th className="table-th">Mark</th>
            <th className="table-th">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-600/50">
          {assignments.map((assignment) => (
            <Assignment key={assignment.id} assignment={assignment} />
          ))}
        </tbody>
      </table>
    );
  }

  return <div className="overflow-x-auto mt-4">{content}</div>;
};

export default AssignmentList;
